import groupBy from 'lodash/groupBy';

async function checkVincols(cartSettings, bet, allowIntegralLiveBet = false) {
    return new Promise(async (resolve, reject) => {
        var errors = [];
        var warnings = [];
        const errorsMultInfo = [];

        var checkCartTypeVincols = await cartTypeVincols(cartSettings, bet, allowIntegralLiveBet);
        if (checkCartTypeVincols.length > 0) {
            errors.push(...checkCartTypeVincols);
        }

        var checkCartContextVincols = await cartContextVincols(cartSettings, bet);
        if (checkCartContextVincols.length > 0) {
            errors.push(...checkCartContextVincols);
        }

        errors.push(...sameEventVincols(cartSettings, bet, allowIntegralLiveBet));

        if (bet.type == "system") {
            // TODO system checkVincols

            var checkAmountVincols = await amountVincols(bet, cartSettings.minAmount, cartSettings.live_min_amount, cartSettings.live_max_amount);
            if (checkAmountVincols.length > 0) {
                errors.push(...checkAmountVincols);
            }

            if (bet.odds.length > 10) {
                errors.push({message: "maximumOddsSystem"});
            }

        } else {
            // LA NUOVA GESTIONE MOLTEPLICITÀ
            var checkMultiplicityVincols = await multiplicityVincols(bet);
            if (checkMultiplicityVincols.length > 0) {
                // Pushiamo nel classico errors così Vuex lo mappa e lo salva
                errors.push(...checkMultiplicityVincols);
            }

            var checkAmountVincols = await amountVincols(bet, cartSettings.minAmount, cartSettings.live_min_amount, cartSettings.live_max_amount);
            if (checkAmountVincols.length > 0) {
                errors.push(...checkAmountVincols);
            }

            const checkMultiplicityVincolsInfo = await multiplicityVincolsInfo(bet);
            if (checkMultiplicityVincolsInfo.length > 0) {
                errorsMultInfo.push(...checkMultiplicityVincolsInfo);
            }
        }

        var checkFlattening = await flattening(bet, cartSettings.max_winning, cartSettings.max_odds, cartSettings.live_max_winning);
        if (checkFlattening.length > 0) {
            warnings.push(...checkFlattening);
        }

        var checkMulitplicityTotal = await checkMultiplicityTotal(bet, cartSettings.live_max_multiplicity);
        if (checkMulitplicityTotal.length > 0) {
            errors.push(...checkMulitplicityTotal);
        }

        // Quote disabilitate dal backend (ODD_DISABLED): rendono il carrello non piazzabile
        // e l'errore deve persistere in bet.errors finché la quota non viene rimossa.
        if (bet.odds && bet.odds.some(function(o) { return o.disabled === true; })) {
            errors.push({ type: 'ODD_DISABLED', message: 'errors.oddDisabledReason' });
        }

        resolve({
            warnings: warnings,
            errors: errors,
            check: (errors.length == 0),
            errors_multi_info: errorsMultInfo
        });
    });
}

async function cartTypeVincols(cartSettings, bet, allowIntegralLive = false) {
    return new Promise(async (resolve, reject) => {
        var errors = [];

        if (!cartSettings.single && bet.type == "single") {
            errors.push({message: "singleNotAllowed"});
        } else if (!cartSettings.multiple && bet.type == "multiple") {
            errors.push({message: "multipleNotAllowed"});
        } else if (bet.type == 'integral') {
            if (allowIntegralLive === true) {
                if(!cartSettings.integral){
                    errors.push({message: "integralNotAllowed"});
                }
            } else {
                if(!cartSettings.integral || ((bet.context == 'live' || bet.context == 'mixed'))){
                    errors.push({message: "integralNotAllowed"});
                }
            }
        } else if (!cartSettings.system && bet.type == "system" || ((bet.context == 'live' || bet.context == 'mixed') && bet.type == 'system')) {
            errors.push({message: "systemNotAllowed"});
        }
        resolve(errors);
    });
}

async function cartContextVincols(cartSettings, bet) {
    return new Promise(async (resolve, reject) => {
        var errors = [];
        if ((bet.context == 'live' || bet.context == 'mixed') && !cartSettings.enableLive) {
            errors.push({message: "liveNotEnabled"});
        }
        var odds = JSON.parse(JSON.stringify(bet.odds));
        var grouped_odds = groupBy(odds, 'type');
        var types = Object.keys(grouped_odds);

        if (types.length > 1) {
            if (types.includes('antepost')) {
                errors.push({message: "antepostCombinabilityNotAllowed"});
            }
            resolve(errors);
        } else {
            resolve(errors);
        }
    });
}

async function amountVincols(bet, minAmount, live_min_amount, live_max_amount) {
    return new Promise(async (resolve, reject) => {
        var errors = [];
        var amount = 0;

        if (bet.type == "single" || bet.type == "multiple") {
            amount = +bet._multiple_detail.amount;
        } else if (bet.type == "integral") {
            amount = +bet._integral_detail.amount;
        } else if (bet.type == "system") {
            amount = +bet._system_detail.amount_system;
        }

        if (bet.context == 'prematch') {
            if (minAmount != undefined && minAmount > 0 && amount < +minAmount) {
                errors.push({message: "minimumAmountNotRespected", value: +minAmount});
            }
        } else if (bet.context == 'mixed' || bet.context == 'live') {
            if (+live_min_amount != undefined && +live_min_amount > 0 && amount < +live_min_amount) {
                errors.push({message: "minimumAmountNotRespected", value: +live_min_amount});
            }
            if (+live_max_amount != undefined && +live_max_amount > 0 && amount > +live_max_amount) {
                errors.push({message: "maximumAmountNotRespected", value: +live_max_amount});
            }
        }
        resolve(errors);
    });
}

// LA NUOVA FUNZIONE PER LA MOLTEPLICITÀ (I18N E INFINTY)
async function multiplicityVincols(bet) {
    return new Promise(async (resolve, reject) => {
        let errors = [];
        let multiplicity = 0;

        if (bet.type == "single" || bet.type == "multiple") {
            multiplicity = +bet._multiple_detail.multiplicity;
        } else if (bet.type == "integral") {
            multiplicity = +bet._integral_detail.multiplicity;
        }

        if (!bet.odds || bet.odds.length === 0) {
            return resolve(errors);
        }

        let globalMin = 1;
        let globalMax = Infinity;
        let minCulpritName = null;
        let maxCulpritName = null;

        for (let odd of bet.odds) {
            let oddMin = +odd.multiplicity_min || 1;
            let oddMax = (+odd.multiplicity_max > 0) ? +odd.multiplicity_max : Infinity;

            if (oddMin > globalMin) {
                globalMin = oddMin;
                minCulpritName = odd.event_description || odd.match_name;
            }
            if (oddMax < globalMax) {
                globalMax = oddMax;
                maxCulpritName = odd.event_description || odd.match_name;
            }
        }

        if (globalMin > globalMax) {
            errors.push({
                type: "MULTIPLICITY_CONFLICT",
                messageKey: "cart.error.multiplicity.conflict",
                messageParams: { min: globalMin, max: globalMax }
            });
            return resolve(errors);
        }

        const minCulpritsCount = bet.odds.filter(o => (+o.multiplicity_min || 1) === globalMin).length;
        const maxCulpritsCount = bet.odds.filter(o => ((+o.multiplicity_max > 0) ? +o.multiplicity_max : Infinity) === globalMax).length;

        const allSameMin = minCulpritsCount === bet.odds.length;
        const allSameMax = maxCulpritsCount === bet.odds.length;

        if (multiplicity < globalMin) {
            const diff = globalMin - multiplicity;

            let msgKey = "cart.error.multiplicity.too_low.all";
            let msgParams = { diff: diff, min: globalMin };

            if (!allSameMin) {
                if (minCulpritsCount > 1) {
                    msgKey = "cart.error.multiplicity.too_low.multiple";
                    msgParams = { min: globalMin };
                } else {
                    msgKey = "cart.error.multiplicity.too_low.single";
                    msgParams = { min: globalMin, eventName: minCulpritName };
                }
            }

            errors.push({
                type: "MULTIPLICITY_TOO_LOW",
                globalMin: globalMin,
                globalMax: globalMax,
                culprit: allSameMin ? null : "UI_WILL_HIGHLIGHT",
                messageKey: msgKey,
                messageParams: msgParams
            });
        }
        else if (multiplicity > globalMax) {
            const diff = multiplicity - globalMax;

            let msgKey = "cart.error.multiplicity.too_high.all";
            let msgParams = { diff: diff, max: globalMax };

            if (!allSameMax) {
                if (maxCulpritsCount > 1) {
                    msgKey = "cart.error.multiplicity.too_high.multiple";
                    msgParams = { max: globalMax };
                } else {
                    msgKey = "cart.error.multiplicity.too_high.single";
                    msgParams = { max: globalMax, eventName: maxCulpritName };
                }
            }

            errors.push({
                type: "MULTIPLICITY_TOO_HIGH",
                globalMin: globalMin,
                globalMax: globalMax,
                culprit: allSameMax ? null : "UI_WILL_HIGHLIGHT",
                messageKey: msgKey,
                messageParams: msgParams
            });
        }

        resolve(errors);
    });
}

// Vecchia funzione mantenuta per retrocompatibilità
async function multiplicityVincolsInfo(bet) {
    return new Promise(async (resolve, reject) => {
        const errors = [];
        let multiplicity = 0;
        if (bet.type == "single" || bet.type == "multiple") {
            multiplicity = +bet._multiple_detail.multiplicity;
        } else if (bet.type == "integral") {
            multiplicity = +bet._integral_detail.multiplicity;
        }

        let multi_minimum = 0;
        for (let odd of bet.odds) {
            if (odd.multiplicity_min > multi_minimum) {
                multi_minimum = odd.multiplicity_min;
            }
        }

        if (multiplicity < multi_minimum) {
            errors.push({message: "multiplicity_info_" + multi_minimum});
        }
        resolve(errors);
    });
}

async function flattening(bet, prematch_max_winning, prematch_max_odds, live_max_winning) {
    return new Promise(async (resolve, reject) => {
        var warnings = [];
        var errorMaxWinning = {message: "max_winning_reached"};
        var errorMaxOdds = {message: "max_odds_reached"};

        if (bet.context == 'prematch') {
            switch (bet.type) {
                case "single":
                case "multiple":
                    if (prematch_max_winning != undefined && +prematch_max_winning > 0 && bet._multiple_detail.winning_total > +prematch_max_winning) {
                        bet._multiple_detail.winning_total = +prematch_max_winning;
                        errorMaxWinning.value = +prematch_max_winning;
                        warnings.push(errorMaxWinning);
                    }
                    if (prematch_max_odds != undefined && +prematch_max_odds > 0 && bet._multiple_detail.odds_total > +prematch_max_odds) {
                        bet._multiple_detail.odds_total = +prematch_max_odds;
                        errorMaxOdds.value = +prematch_max_odds;
                        warnings.push(errorMaxOdds);
                    }
                    break;
                case "integral":
                    if (prematch_max_winning != undefined && +prematch_max_winning > 0 && bet._integral_detail.winning_total_max > +prematch_max_winning) {
                        bet._integral_detail.winning_total_max = +prematch_max_winning;
                        errorMaxWinning.value = +prematch_max_winning;
                        warnings.push(errorMaxWinning);
                    }
                    if (prematch_max_odds != undefined && +prematch_max_odds > 0 && bet._integral_detail.odds_total_max > +prematch_max_odds) {
                        bet._integral_detail.odds_total_max = +prematch_max_odds;
                        errorMaxOdds.value = +prematch_max_odds;
                        warnings.push(errorMaxOdds);
                    }
                    break;
                case "system":
                    if (prematch_max_winning != undefined && +prematch_max_winning > 0 && bet._system_detail.winning_total_max > +prematch_max_winning) {
                        bet._system_detail.winning_total_max = +prematch_max_winning;
                        errorMaxWinning.value = +prematch_max_winning;
                        warnings.push(errorMaxWinning);
                    }
                    break;
            }
        } else if (bet.context == 'live' || bet.context == 'mixed') {
            switch (bet.type) {
                case "single":
                case "multiple":
                    if (live_max_winning != undefined && +live_max_winning > 0 && bet._multiple_detail.winning_total > +live_max_winning) {
                        bet._multiple_detail.winning_total = +live_max_winning;
                        errorMaxWinning.value = +live_max_winning;
                        warnings.push(errorMaxWinning);
                    }
                    break;
                case "integral":
                    if (live_max_winning != undefined && +live_max_winning > 0 && bet._integral_detail.winning_total_max > +live_max_winning) {
                        bet._integral_detail.winning_total_max = +live_max_winning;
                        errorMaxWinning.value = +live_max_winning;
                        warnings.push(errorMaxWinning);
                    }
                    break;
                case "system":
                    if (live_max_winning != undefined && +live_max_winning > 0 && bet._system_detail.winning_total_max > +live_max_winning) {
                        bet._system_detail.winning_total_max = +live_max_winning;
                        errorMaxWinning.value = +live_max_winning;
                        warnings.push(errorMaxWinning);
                    }
                    break;
            }
        }
        resolve(warnings);
    });
}

async function checkMultiplicityTotal(bet, live_max_multiplicity) {
    return new Promise(async (resolve, reject) => {
        var errors = [];
        if (bet.context == 'prematch') {
            //
        } else if (bet.context == 'live' || bet.context == 'mixed') {
            switch (bet.type) {
                case "single":
                case "multiple":
                    if (live_max_multiplicity != undefined && +live_max_multiplicity > 0 && +bet._multiple_detail.multiplicity > +live_max_multiplicity) {
                        errors.push({message: "max_multiplicity_not_respected"});
                    }
                    break;
                case "integral":
                    if (live_max_multiplicity != undefined && +live_max_multiplicity > 0 && +bet._integral_detail.multiplicity > +live_max_multiplicity) {
                        errors.push({message: "max_multiplicity_not_respected"});
                    }
                    break;
                case "system":
                    break;
            }
        }
        resolve(errors);
    });
}

// Two selections of one event in a single / multiple, outside a bet builder group. rocky-bets
// counts a bet builder group as one selection and makes two selections of the same event an
// integral (cartCalculator.getCartTypeV2), so it refuses such a slip at placement with
// cart_type_mismatch. Said here instead, with the bet button disabled. Happens when a
// selection could not join the event's bet builder (e.g. a live combination that can no
// longer win) and the skin allows integrals, so the cart keeps both.
function sameEventVincols(cartSettings, bet, allowIntegralLive = false) {
    if (bet.type !== 'single' && bet.type !== 'multiple') return [];
    const seenGroups = new Set();
    const perEvent = {};
    for (const odd of bet.odds || []) {
        if (odd.is_bet_builder && odd.bet_builder_id) {
            if (seenGroups.has(odd.bet_builder_id)) continue;
            seenGroups.add(odd.bet_builder_id);
        }
        const event = String(odd.event_source);
        perEvent[event] = (perEvent[event] || 0) + 1;
    }
    if (!Object.values(perEvent).some(count => count > 1)) return [];
    // Same conditions as cartTypeVincols for an integral to be playable.
    const live = bet.context === 'live' || bet.context === 'mixed';
    const integralPlayable = Boolean(cartSettings.integral) && (allowIntegralLive === true || !live);
    return [{message: integralPlayable ? 'sameEventNotCombinableIntegral' : 'sameEventNotCombinable'}];
}

export default {
    checkVincols,
    sameEventVincols,
}